// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__1aY4M","marketplaceStroke":"IconEmailAttention_marketplaceStroke__2bCoI","attentionStroke":"IconEmailAttention_attentionStroke__1n65T"};